__turbopack_context__.v({
  "avatar": "AvatarGroup-module-scss-module__2CECBG__avatar",
  "avatarAttended": "AvatarGroup-module-scss-module__2CECBG__avatarAttended",
  "img": "AvatarGroup-module-scss-module__2CECBG__img",
  "root": "AvatarGroup-module-scss-module__2CECBG__root",
});
